import { create } from 'zustand';

const useCheckupCardStore = create((set) => ({
    cardDisableIndexMap: {
        All: [],
        Light: [6, 7, 8],
        Wave: [7, 8],
        Bounce: [6],
        Premium: []
    },
    checkupCardItems: [
        {
            cardName: "수면 검사",
            imgClassName: "sleep",
            isEnable: true,
            desc: "숨소리를 통해 수면 패턴을 확인할 수 있어요. 나도 몰랐던 나의 수면 상태를 파악해요."
        },
        {
            cardName: "근골격계",
            imgClassName: "muscle",
            isEnable: true,
            desc: "목, 몸통(허리), 어깨 등 평소 불편했던 부위를 촬영하여 나의 자세를 측정해보세요​."
        },
        {
            cardName: "인지기능",
            imgClassName: "recognition",
            isEnable: true,
            desc: "간단한 문항을 통해 뇌 건강을 살펴요. 기억력, 인지능력을 종합적으로 살펴보세요."
        },
        {
            cardName: "스트레스",
            imgClassName: "stress",
            isEnable: true,
            desc: "나의 스트레스 수준은 어느 정도이고, 어떤 부분에서 스트레스가 취약한지 확인해보세요."
        },
        {
            cardName: "전립선<br/>건강",
            imgClassName: "prostate",
            isEnable: true,
            desc: "소변 배출 속도로 나의 전립선 건강을 체크해요."
        },
        {
            cardName: "월경 전<br/>증후군",
            imgClassName: "pms",
            isEnable: true,
            desc: "월경 전에 경험하는 신체적, 정신적, 행동적 변화를 유형으로 나누어 확인해봐요."
        },
        {
            cardName: "CGM<br/>(연속혈당)",
            imgClassName: "cgm",
            isEnable: true,
            desc: "14일 간 시시각각 달라지는 내 혈당을 확인해보세요. ​"
        },
        {
            cardName: "심전도",
            imgClassName: "cardiogram",
            isEnable: true,
            desc: "심장 리듬의 모니터링을 통해 내 심장이 보내는 건강 신호를 확인해보세요​."
        },
        {
            cardName: "보행분석",
            imgClassName: "walking",
            isEnable: true,
            desc: "평소의 나의 걸음걸이가 궁금했다면, 걷기만으로 나의 보행 패턴을 분석해보세요​."
        },
    ],
    setCardDisable: (type) => set((state) => {
        const disabledIndexes = new Set(state.cardDisableIndexMap[type] || []);
        const updatedItems = state.checkupCardItems.map((item, idx) => ({
            ...item,
            isEnable: !disabledIndexes.has(idx)
        }));

        return {
            checkupCardItems: updatedItems
        };
    }),
}));

export default useCheckupCardStore;